import { Route, Routes } from "react-router-dom";
import Home from "../pages/index.js";
import Domain from "../pages/domain/index.js";
import Hosting from "../pages/hosting/index.js";
import ContactUs from "../pages/contact/index.js";
import CheckoutForm from "../comps/CheckoutForm.js";
import Account from "../pages/account/index.js";
import NotFoundPage from "../pages/404/index.js";
import Login from "../pages/auth/Login.js"
import SignUp from "../pages/auth/SignUp.js";
import Privacy from "../pages/privacy/Privacy.js";
import TermsOfService from "../pages/terms/Terms.js";
import PaymentSuccess from "../pages/successfailedpages/Success.js";
import PaymentCancel from "../pages/successfailedpages/Cancel.js";
import Knowledge from "../pages/knowledge-center/index.js";
import KnowledgeDetail from "../pages/knowledge-center/KnowledgeDetail.js";
import User_Profile from "../pages/user_profile/User_Profile.js";
import Protected_Routes from "../protected/Protected_Routes.js";
import User_Profile_Edit from "../pages/user_profile/User_Profile_Edit.js";
import Blog_Details from "../pages/blog/Blog_Details.js";
import Blog_List from "../pages/blog/Blog_List.js";
import Cart from "../pages/cart/Cart.js";
import Order from "../pages/order/Order.js";
import Address from "../pages/address/Address.js";
import Billing_Address from "../pages/address/Billing_Address.js";
import Shipping_Address from "../pages/address/Shipping_Address.js";
import Edit_Billing_Address from "../pages/address/Edit_Billing_Address.js";
import Edit_Shipping_Address from "../pages/address/Edit_Shipping_Address.js";
import Forgot_Password_Email from "../pages/auth/Forgot_Password_Email.js";
import Forgot_Password from "../pages/auth/Forgot_Password.js";
import Web_Development from "../pages/web_development/Web_Development.js";
import Shared_Hosting from "../pages/shared_hosting/Shared_Hosting.js";
import Vps_Hosting from "../pages/vps_hosting/Vps_Hosting.js";
import Dedicated_Hosting from "../pages/dedicated_hosting/Dedicated_Hosting.js";
import WordPress_Hosting from "../pages/wordpress_hosting/Wordpress_Hosting.js";
import PdfViewer from "../pages/pdf.js";
import OrerDetail from "../pages/order/order_detail.js";

const Layout = (props) => {

      return (
            <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/home" element={<Home />} />
                  <Route path="/agreement" element={<PdfViewer />} />
                  <Route path="/domain" element={<Domain />} />
                  <Route path="/hosting" element={<Hosting />} />
                  <Route path="/web_development" element={<Web_Development />} />
                  <Route path="/contact-us" element={<ContactUs />} />
                  <Route path="/checkout" element={<CheckoutForm />} />
                  <Route path="/order-detail/:id" element={<OrerDetail />} />
                  <Route path="/my-account" element={<Account />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/forgot_password_email" element={<Forgot_Password_Email />} />
                  <Route path="/forgot_password" element={<Forgot_Password />} />
                  <Route path="/privacy-policy" element={<Privacy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/success" element={<PaymentSuccess />} />
                  <Route path="/cancel" element={<PaymentCancel />} />
                  <Route path="/knowledge-center" element={<Knowledge />} />
                  <Route path="/knowledge-center-detail/:id" element={<KnowledgeDetail />} />
                  <Route path="/blog-details/:id" element={<Blog_Details />} />
                  <Route path="/blog-list" element={<Blog_List />} />
                  <Route path="/shared-hosting" element={<Shared_Hosting />} />
                  <Route path="/vps-hosting" element={<Vps_Hosting />} />
                  <Route path="/dedicated-hosting" element={<Dedicated_Hosting />} />
                  <Route path="/wordpress-hosting" element={<WordPress_Hosting />} />
                  <Route path='/user-profile' element={<Protected_Routes Component={User_Profile} />} />
                  <Route path='/user-profile-edit' element={<Protected_Routes Component={User_Profile_Edit} />} />
                  <Route path='/cart' element={<Protected_Routes Component={Cart} />} />
                  {/* <Route path='/cart' element={<Cart />}/> */}
                  <Route path='/order' element={<Protected_Routes Component={Order} />} />
                  <Route path='/address' element={<Protected_Routes Component={Address} />} />
                  <Route path='/billing_address' element={<Protected_Routes Component={Billing_Address} />} />
                  <Route path='/shipping_address' element={<Protected_Routes Component={Shipping_Address} />} />
                  <Route path='/edit_billing_address' element={<Protected_Routes Component={Edit_Billing_Address} />} />
                  <Route path='/edit_shipping_address' element={<Protected_Routes Component={Edit_Shipping_Address} />} />
                  <Route path="/404" element={<NotFoundPage />} />
                  <Route path="*" element={<NotFoundPage />} />
            </Routes>
      );
};
export default Layout;
